import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'views/components';
import {translate} from 'views/module';

import SubscribeUserDialog from '../dialogs/SubscribeUserDialog';
import ConfirmDialog from '../dialogs/ConfirmDialog';

const SmsNotification = (props) => {
  const {clientBackend, relationshipData, smsData} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [confirmAction, setConfirmAction] = React.useState(null);
  const [confirmDialogProps, setConfirmDialogProps] = React.useState({});
  const [smsNumber, setSmsNumber] = React.useState(smsData.smsNumber ?? '');

  React.useEffect(() => {
    setSmsNumber(smsData.smsNumber);
  }, [smsData.smsNumber]);

  const createUserSms = async (smsNumber) => {
    setIsLoading(true);
    await clientBackend.notification.createUserSms(
        relationshipData.relationshipRn,
        smsNumber,
        () => setIsLoading(false),
    );
  };

  const handleSubmitSmsNumber = (input) => {
    createUserSms(input);
    setShowDialog(false);
  };

  const removeUserSms = async () => {
    setIsLoading(true);
    await clientBackend.notification.removeUserSms(
        relationshipData.relationshipRn,
        smsNumber,
        () => setIsLoading(false),
    );
  };

  const handleOpenDialog = () => {
    setSmsNumber(smsNumber.trim());
    setShowDialog(true);
  };

  const handleConfirm = async () => {
    if (confirmAction) {
      await confirmAction();
    }
    setShowConfirmDialog(false);
  };

  const getButtonConfig = () => {
    if (smsData.isSubscribedForNotification) {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Active'),
        action: () => {
          setConfirmDialogProps({
            title: translate(
                'client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Title',
            ),
            message: translate(
                'client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Message',
            ),
            confirmText: translate(
                'client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.ConfirmButton',
            ),
          });
          setConfirmAction(() => removeUserSms);
          setShowConfirmDialog(true);
        },
      };
    } else {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Setup'),
        action: handleOpenDialog,
      };
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <>
      <Button
        onClick={buttonConfig.action}
        variant='contained'
        size='small'
        disabled={isLoading}
        sx={{color: 'color.white'}}
      >
        {buttonConfig.text}
      </Button>
      {
        showDialog &&
        <SubscribeUserDialog
          open={showDialog}
          onClose={() => {
            setShowDialog(false);
          }}
          onSubmit={handleSubmitSmsNumber}
          initialChannelValue={smsNumber}
          isLoading={isLoading}
          channelType='Sms'
          channel={'Notification'}
          errorMessage={translate('client.ClientDetail.Relationships.Contacts.Dialogs.SmsHelperText.FailRegexMessage')}
          regex={/^\+?1?\s*(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/}
        />
      }
      {
        showConfirmDialog &&
        <ConfirmDialog
          open={showConfirmDialog}
          title={confirmDialogProps.title}
          message={confirmDialogProps.message}
          onCancel={() => setShowConfirmDialog(false)}
          onConfirm={handleConfirm}
          confirmText={confirmDialogProps.confirmText}
          cancelText={translate('client.ClientDetail.Relationships.Contacts.Dialogs.Cancel')}
          isLoading={isLoading}
        />
      }
    </>
  );
};

SmsNotification.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  smsData: PropTypes.shape({
    smsNumber: PropTypes.string.isRequired,
    isSubscribedForNotification: PropTypes.bool.isRequired,
  }).isRequired,
  relationshipData: PropTypes.object.isRequired,
};

export default SmsNotification;
